import React, { useCallback, useState, useEffect } from 'react'
import { Fade } from 'react-reveal';
import badgeStarter from '../../../images/badge starter.png'
import badgePro from '../../../images/badge pro.png'
import badgePlus from '../../../images/badge starter plus.png'
import badgeBusiness from '../../../images/badge business orange.png'
import { CheckBadgeIcon } from '@heroicons/react/24/solid'
import { useDispatch, useSelector } from 'react-redux';

import { fetchProducts, getSubscribe } from '../../../features/forfait/forfaitSlice';
import { selectUserInfo } from '../../../features/users/userInfoSlice';
import Spinner from '../../../components/Spinner';
import Product from '../../../components/Product';
import { api } from '../../../api';
import toast from 'react-hot-toast';
import { APP_CONTRACT_LINK, REMOTE_PRODUCT_SELECTED_KEY } from '../../../constants';
import ToastAction from '../../../components/ToastAction';
import NormalSara from '../../../images/SARA_Expression/normal.png'
import { StandardDialog } from '../../../components/modals';
import FormBtn from '../../../components/elements/Buttons/FormBtn';

const srcMap = {
  STARTER: badgeStarter,
  'STARTER PLUS': badgePlus,
  PRO: badgePro
};

function Subcribe() {
  const dispatch = useDispatch();
  const userInfoContext = useSelector(selectUserInfo)
  const loadingProducts = useSelector(state => state.subscriptions.loading)
  /**
   * @type {Product[]}
   */
  const products = useSelector(state => state.subscriptions.products)
  const subscribeProduct = useSelector(state => state.subscriptions.product)

  const [open, setOpen] = useState(false)
  const [productSelected, setProductSelected] = useState(null)

  const remoteProductId = localStorage.getItem(REMOTE_PRODUCT_SELECTED_KEY)


  useEffect(() => {
    if (remoteProductId) {
      toast.custom((t) => <ToastAction saraExpression="wink" toastRef={t} label="Votre forfait sélectionné depuis notre site internet en surbrillance." description="Vous pouvez le changer ou le confirmer." />
      )
    }
    products.length <= 0 && dispatch(fetchProducts())
    dispatch(getSubscribe({ company_id: userInfoContext?.user?.company_id }))
  }, [userInfoContext?.user?.company_id])

  const handleCloseDialog = useCallback(() => {
    setOpen(false);
  }, [])

  const handleOpenDialog = useCallback(() => {
    setOpen(true);
  }, [])

  const _subscribe = useCallback(async (e) => {
    e.preventDefault()
    if (!productSelected) return toast.custom((t) => <ToastAction saraExpression="thinking" toastRef={t} label="Aucun forfait selectionné !" description="Veuillez sélectionner un forfait SVP." />)
    const idLoading = toast.loading('Subscription en cours...')
    try {
      const { session_url } = await api.stripe().subscribe(productSelected.price_id, userInfoContext?.user?.company_id)
      toast.dismiss(idLoading)
      window.open(session_url, '_self')
      if (remoteProductId) localStorage.removeItem(REMOTE_PRODUCT_SELECTED_KEY)
    } catch (error) {
      console.log(error);
      toast.dismiss(idLoading)
      toast.custom((t) => <ToastAction saraExpression="sorry" toastRef={t} label="Oups !!" description="Nous avons rencontré un problème. Veuillez réessayer SVP." />)
    }
  }, [userInfoContext?.user?.company_id, productSelected])

  /**
   * @param {Product} product
   */
  const _preSubscribe = (product) => {
    //NOTE: Uncomment this code below to activate guard for checking info company before handle subscription stripe
    // const { company } = userInfoContext?.user

    // if (!company.legal_name || !company.siren) {
    //   return toast.custom(t =>
    //     <ToastAction
    //       toastRef={t}
    //       label="Pas assez d'information"
    //       description="Voulez-vous compléter vos informations d'entreprise maintenant ?"
    //       saraExpression="thinking"
    //       okAction={() => history.push('/account')}
    //     />
    //   )
    // }
    setProductSelected(product)
    handleOpenDialog()
  }

  const _contactUs = () => {
    toast.custom(t =>
      <ToastAction
        toastRef={t}
        label="Contactez-nous au (0)1 89 27 00 11"
        description="Prendre un rendez-vous maintenant ?"
        saraExpression="normal"
        okAction={() => window.open('https://calendly.com/azatys/expert?month=2022-12&date=2022-12-13', '_blank')}
      />
    )
  }

  if (loadingProducts && products.length <= 0) {
    return <div className="min-h-screen mx-auto w-[500px] flex justify-center items-center">
      <Spinner />
    </div>
  }

  return (
    <div className='my-10 mx-auto max-w-lg lg:max-w-none lg:px-20'>
      <StandardDialog open={open} onClose={handleCloseDialog}>
        <div className="bg-white rounded-3xl flex flex-col justify-between items-center space-y-4">
          <img src={NormalSara} alt="SARA_NORMAL" className="h-48" />
          <form onSubmit={_subscribe} className="text-center px-10 space-y-8 max-w-2xl">
            {
              productSelected?.title?.toLowerCase() === 'starter' ?
                <p className="text-gray-800 text-center text-lg h-full pt-5 font-semibold">
                  Avant de profiter des fonctionnalités du forfait STARTER à 0€, merci d'accepter nos conditions contractuelles d'utilisation.
                </p> :
                <p className="text-gray-800 text-sm h-full text-justify pt-5 font-semibold">
                  Profitez gratuitement pendant 1 mois des fonctionnalités du forfait <strong>{productSelected?.title?.toUpperCase()}</strong>. <br /> <br />
                  Vous serez prévenus 7 jours avant la fin de la période d’essai par email, n’hésitez pas à intégrer dès à présent dans vos contacts notre adresse <a href="mailto:info@azatys.fr">info@azatys.fr</a> pour ne rater aucun de nos messages. <br />
                  Vous pourrez, au bout de votre période de gratuité, décider de garder ce forfait ou vous pourrez choisir un autre forfait disponible en vous rendant sur cette même page.
                  <br /> <br />
                  Avant de pouvoir profiter des fonctionnalités de votre forfait  merci d’accepter nos conditions contractuelles d’utilisation.
                </p>
            }
            <div>
              <label htmlFor="permanent_close" className="flex items-center space-x-2 text-sm text-gray-500 cursor-pointer">
                <input required type="checkbox" name="permanent_close" id="permanent_close" className="checkbox checkbox-sm checkbox-accent peer" />
                <span className="peer-checked:text-general-teal">
                  <a data-tip="Lire nos conditions contractuelles." href={APP_CONTRACT_LINK} target="_blank" className="text-general-blue underline tooltip">J'accepte</a> les conditions contractuelles de la plateforme Azatys.
                </span>
              </label>
            </div>
            <footer className="flex items-center justify-around space-x-3 mx-auto max-w-xs">
              <FormBtn label="J'y vais" />
              <button type="button" onClick={handleCloseDialog} className='btn py-3 uppercase tracking-wide font-medium text-sm bg-gray-500 hover:bg-gray-600 transition-colors hover:border-none disabled:text-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed'>
                J'annule ma demande
              </button>
            </footer>
          </form>
        </div>
      </StandardDialog>
      <h1 className="text-center font-semibold text-gray-600 text-sm w-full my-8">Choisissez votre forfait SANS ENGAGEMENT</h1>
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5'>
        <div className='flex flex-col w-[300px] mx-auto sm:w-full gap-3 lg:col-span-2'>
          <Fade left cascade>
            <section className='flex flex-wrap mx-auto sm:mx-0 gap-5'>
              {products.filter(product => product.display).map(product => <Product key={product.product_id} badge={srcMap[product.title.toUpperCase()]} product={product} remoteProductId={remoteProductId} onClick={_preSubscribe} />)}
            </section>
          </Fade>
          <Fade><p className="text-sm font-bold text-gray-500">Pilotez les performances de votre site internet en toute simplicité !</p></Fade>
          <Fade>
            <table className='text-sm text-left text-gray-500 shadow rounded-lg overflow-hidden'>
              <thead className='text-xs text-general-teal bg-white border-b'>
                <tr>
                  <th className="py-3 px-3">
                    <div className="flex items-center space-x-2">
                      <span>Vos droits de compte</span>
                    </div>
                  </th>
                  <th rowSpan={1} className="py-3 w-[100px]">
                    <img src={badgeStarter} alt='Starter Plan' className='h-6 mx-auto' />
                  </th>
                  <th rowSpan={1} className="py-3 w-[100px]">
                    <img src={badgePlus} alt='Starter Plus Plan' className='h-6 mx-auto' />
                  </th>
                  <th className="py-3 w-[100px]">
                    <img src={badgePro} alt='Pro Plan' className='h-6 mx-auto' />
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white overflow-hidden shadow">
                <tr className='bg-white border-b'>
                  <td className='py-2 px-3 font-medium text-gray-500 text-xs'>Utilisateur(s) inclus</td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>Jusqu'à 1 utilisateur</td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>Jusqu'à 3 utilisateurs</td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                    Jusqu'à 5 utilisateurs
                  </td>
                </tr>
                <tr className='bg-white'>
                  <td className='py-2 px-3 font-medium text-gray-500 text-xs'>Site(s) concurrent(s) inclus</td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>0 concurrent</td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>Jusqu'à 1 concurrent</td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                    Jusqu'à 3 concurrents
                  </td>
                </tr>
              </tbody>
            </table>
          </Fade>
          <Fade bottom>
            <table className='text-sm text-left text-gray-500 shadow rounded-lg overflow-hidden'>
              <thead className='text-xs text-general-teal bg-white border-b'>
                <tr>
                  <th className="py-3 px-3">
                    <div className="flex items-center space-x-2">
                      <span>Suivi des indicateurs de vos performances digitales</span>
                    </div>
                  </th>
                  <th rowSpan={1} className="py-3 w-[84px]">
                  </th>
                  <th rowSpan={1} className="py-3 w-[84px]">
                  </th>
                  <th className="py-3 w-[84px]">
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white overflow-hidden shadow">
                <tr className='bg-white border-b'>
                  <td className='py-2 px-3 font-medium whitespace-nowrap text-gray-500 text-xs'>
                    Notation et suivi des indicateurs de performance de vos sources de trafic
                  </td>
                  <td className='py-2 font-medium whitespace-nowrap text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                  <td className='py-2 font-medium whitespace-nowrap text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                  <td className='py-2 font-medium whitespace-nowrap text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                </tr>
                <tr className='bg-white border-b'>
                  <td className='py-2 px-3 font-medium text-gray-500 text-xs'>
                    Explications de vos résultats par SARA et recommandations d'optimisations de premier niveau
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                </tr>
                <tr className='bg-white'>
                  <td className='py-2 px-3 font-medium text-gray-500 text-xs'>
                    Comparaison de vos notations avec votre ou vos concurrents
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'></td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                </tr>
              </tbody>
            </table>
          </Fade>

          <Fade bottom>
            <table className='text-sm text-left text-gray-500 shadow rounded-lg overflow-hidden w-full' >
              <thead className='text-xs text-general-teal bg-white border-b'>
                <tr>
                  <th className="py-3 px-3">
                    <div className="flex items-center space-x-2">
                      <span>Suivi des indicateurs de pilotage de votre activité digitale</span>
                    </div>
                  </th>
                  <th rowSpan={1} className="py-3 w-[84px]">
                  </th>
                  <th rowSpan={1} className="py-3 w-[84px]">
                  </th>
                  <th className="py-3 w-[84px]">
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white overflow-hidden shadow">
                <tr className='bg-white border-b'>
                  <td className='py-2 px-3 font-medium whitespace-nowrap text-gray-500 text-xs'>
                    Suivi hebdomadaire et mensuel de vos visites par source et type de trafic. <br />
                    Comparaison vs Historique
                  </td>
                  <td className='py-2 font-medium whitespace-nowrap text-gray-500 text-xs text-center'></td>
                  <td className='py-2 font-medium whitespace-nowrap text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                  <td className='py-2 font-medium whitespace-nowrap text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                </tr>
                <tr className='bg-white'>
                  <td className='py-2 px-3 font-medium text-gray-500 text-xs'>
                    Suivi mensuel de vos profils de visiteurs
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'></td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'></td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                </tr>
              </tbody>
            </table>
          </Fade>

          <Fade bottom>
            <table className='text-sm text-left text-gray-500 shadow rounded-lg overflow-hidden w-full' >
              <thead className='text-xs text-general-teal bg-white border-b'>
                <tr>
                  <th className="py-3 px-3">
                    <div className="flex items-center space-x-2">
                      <span>Nos accompagnements</span>
                    </div>
                  </th>
                  <th rowSpan={1} className="py-3 w-[84px]">
                  </th>
                  <th rowSpan={1} className="py-3 w-[84px]">
                  </th>
                  <th className="py-3 w-[84px]">
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white overflow-hidden shadow">
                <tr className='bg-white border-b'>
                  <td className='py-2 px-3 font-medium whitespace-nowrap text-gray-500 text-xs'>
                    Service client par email
                  </td>
                  <td className='py-2 font-medium whitespace-nowrap text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                  <td className='py-2 font-medium whitespace-nowrap text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                  <td className='py-2 font-medium whitespace-nowrap text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                </tr>
                <tr className='bg-white border-b'>
                  <td className='py-2 px-3 font-medium text-gray-500 text-xs'>
                    Alerting de SARA<sup>(1)</sup> sur vos TOPS et vos FLOPS
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                </tr>
                <tr className='bg-white border-b'>
                  <td className='py-2 px-3 font-medium text-gray-500 text-xs'>
                    Bilan mensuel récapitulatif de vos résultats
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'></td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                </tr>
                <tr className='bg-white'>
                  <td className='py-2 px-3 font-medium text-gray-500 text-xs'>
                    Expert plateforme par téléphone
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                  </td>
                  <td className='py-2 font-medium text-gray-500 text-xs text-center'>
                    <CheckBadgeIcon className='text-teal-600 h-4 mx-auto' />
                  </td>
                </tr>
              </tbody>
            </table>
          </Fade>

          {subscribeProduct && <a href="https://forms.office.com/r/Pjgiwjg3Mg" className='text-right underline text-sm hover:text-gamification-red transition-colors font-medium' target="_blank">Résilier mon abonnement</a>}

          <Fade bottom>
            <p className='text-xs font-semibold text-gray-700 max-w-[730px]'>
              * Forfait disponible en test gratuit durant une période de 1 mois. <br />
              Au delà de cette période, le prélèvement mensuel correspondra au tarif indiqué sur le forfait le jour de l'abonnement.
              Possibilité de modifier ou de résilier l'abonnement avant la fin de la période de gratuité. <br />
              <span className="mb-2 block" />
              * Prix de lancement valable jusqu'au 31 mars 2023. <br />
              À compter de cette date, le forfait et son prix sont susceptibles d'évoluer en fonction de l'ajout de nouvelles fonctionnalités. <br /> <br />
              <span className='animate-pulse hover:animate-none text-general-blue'>** -20% de remise sur nos forfaits à vie si vous faites parti des 50 premiers souscripteurs de la plateforme.</span> <br /> <br />
              (1) Solution d'Analyse et de Recommandations Autonomes
            </p>
          </Fade>
        </div>
        <div className="flex justify-end 2xl:justify-center">
          <Fade right>
            <article className='flex flex-col justify-between rounded-xl bg-white shadow px-4 py-3 w-[250px] max-w-[300px] max-h-[500px] md:max-h-[600px] lg:max-h-[500px] space-y-10 sticky top-20'>
              <div className='border-b border-dashed border-orange-500 flex flex-col items-center justify-center space-y-1 w-full font-semibold text-gamification-orange'>
                <img src={badgeBusiness} alt='Starter Plan' className='h-10' />
                <h3>AZATYS BUSINESS</h3>
              </div>
              <p className='text-center text-xs font-medium text-gray-500'>
                <strong>Vous avez plus d'un site,</strong> vous êtes une agence de communication web, un indépendant spécialisé dans le développement de site internet ou vous voulez tout simplement une offre PERSONNALISÉE ? <br /> <br />
                Nous pouvons vous aider à gagner du temps dans vos analyses ! <br /> <br />
                Notre plateforme vous permet de suivre et piloter les indicateurs de performances de vos sites et ceux de vos clients en un clin d'oeil. <br /> <br />
                Vous pourrez suivre jusqu'à 20 sites par compte administrateur. <br /> <br />
                Alors vous voulez en savoir plus ?
              </p>
              <div className='text-center'>
                <button onClick={_contactUs} className='block rounded-full px-8 py-1.5 w-full uppercase tracking-wide font-medium text-xs text-white bg-gamification-orange/90 hover:bg-gamification-orange hover:shadow transition-all hover:border-none disabled:text-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed'>Contactez-nous</button>
              </div>
            </article>
          </Fade>
        </div>
      </div>
    </div>
  )
}

export default Subcribe